import { Navigate, useNavigate } from "react-router"
import { ACQUISITION_FORM_LINKS } from "../links"
import { CenterWrapper } from "../components/CenterWrapper"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"
import { PaymentForm } from "./PaymentForm"
import { PaymentFormValues, useStoredPaymentFormValues } from "./paymentForm.utils"
import { CustomerType, Product } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { FormHeader } from "../components/FormHeader"
import { useAcquisitionProgress } from "../AcquisitionProgressContext"
import { useProductParam } from "../utils"

type ContentProps = {
  product: Product
  customerType: CustomerType
}

function PaymentPageContent(props: ContentProps) {
  const [paymentInfo, storePaymentInfo] = useStoredPaymentFormValues(props.product)
  const navigate = useNavigate()
  const progress = useAcquisitionProgress()

  function handleReturn() {
    navigate(`..${progress.previousStepUrl}`)
  }

  function handleSubmit(formValues: PaymentFormValues) {
    storePaymentInfo(formValues)
    navigate(`..${progress.nextStepUrl}`)
  }

  return (
    <CenterWrapper>
      <FormHeader>Způsob platby</FormHeader>

      <Spacer size={theme.space.s6} />

      <PaymentForm
        defaultValues={paymentInfo}
        selectedProduct={props.product}
        onReturn={handleReturn}
        onSubmit={handleSubmit}
      />

      <Spacer size={theme.space.s12} />
    </CenterWrapper>
  )
}

export function PaymentPage() {
  const { customerType, contractInfo } = useAcquisitionProgress()
  const product = useProductParam()

  if (!customerType) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CUSTOMER_TYPE}`} />
  }

  if (!contractInfo || (customerType === "household" && !contractInfo.measurementTypeConsent)) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CONTRACT_TYPE(customerType)}`} />
  }

  if (product !== contractInfo.product) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.PAYMENT(customerType, contractInfo.product)}`} />
  }

  return <PaymentPageContent customerType={customerType} product={contractInfo.product} />
}
